<header class="wiz-header">
  <div class="banner">
    <i class="fas fa-hat-wizard hat"></i>
    <h1 class="title">
      <span class="drop">F</span><span class="text">reightmancer&nbsp;Lvl&nbsp;99</span>
    </h1>
  </div>
  <nav class="wiz-tabs">
    <button
      *ngFor="let s of steps; let i = index"
      class="wiz-tab"
      [class.active]="i === active"
      (click)="go(i)"
    >
      <span class="orb"><i class="fas" [ngClass]="s.icon"></i></span>
      <span class="label">{{ s.label }}</span>
    </button>
  </nav>
</header>

<section class="wiz-body">
  <div class="step-container" [@stepAnim]="active">
    <ng-container [ngSwitch]="active">

      <!-- Customer -->
      <form *ngSwitchCase="0" class="step-card" [formGroup]="customerForm">
        <div class="card-content">
          <app-contact-autocomplete
            placeholder="Search customer…"
            [type]="'customer_contact_list'"
            [formControl]="customerNameControl"
            (selected)="onCustomerSelected($event)"
          ></app-contact-autocomplete>

          <div class="address-row">
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Customer Address</mat-label>
              <mat-select formControlName="customer_address">
                <mat-option *ngFor="let a of customerAddresses" [value]="a.value">
                  {{ a.label }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Postal Code</mat-label>
              <input matInput formControlName="customer_postal_code" />
            </mat-form-field>
          </div>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>Documentation</mat-expansion-panel-header>
            <div class="checkbox-group">
              <mat-checkbox formControlName="customer_shipping_bol">Shipping BOL</mat-checkbox>
              <mat-checkbox formControlName="customer_invoice_bol">Invoice BOL</mat-checkbox>
              <mat-checkbox formControlName="customer_invoice_pod_required">Invoice POD</mat-checkbox>
              <mat-checkbox formControlName="customer_invoice_po_required">PO Number</mat-checkbox>

              <mat-form-field
                *ngIf="customerForm.get('customer_invoice_po_required')!.value"
                appearance="fill"
                color="primary"
                class="enhanced-input"
              >
                <mat-label>PO Number</mat-label>
                <input matInput formControlName="customer_invoice_po" />
              </mat-form-field>

              <mat-checkbox formControlName="customer_rate_quote">Rate Quote Invoice</mat-checkbox>
              <mat-checkbox formControlName="customer_consignee_agreement">Consignee Agreement</mat-checkbox>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>Notifications</mat-expansion-panel-header>
            <div class="checkbox-group">
              <mat-checkbox formControlName="customer_at_pickup_notification">At Pick-Up</mat-checkbox>
              <mat-checkbox formControlName="customer_delayed_pickup_notification">Delayed Pick-Up</mat-checkbox>
              <mat-checkbox formControlName="customer_at_delivery_notification">At Delivery</mat-checkbox>
              <mat-checkbox formControlName="customer_delayed_delivery_notification">Delayed Delivery</mat-checkbox>
              <mat-checkbox formControlName="customer_assessorials_incurred_notification">Assessorials Incurred</mat-checkbox>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>Special Programs &amp; Handling</mat-expansion-panel-header>
            <div class="checkbox-group">
              <mat-checkbox formControlName="customer_csa">CSA</mat-checkbox>
              <mat-checkbox formControlName="customer_fast">FAST</mat-checkbox>
              <mat-checkbox formControlName="customer_ace">ACE</mat-checkbox>
              <mat-checkbox formControlName="customer_aci">ACI</mat-checkbox>
              <mat-checkbox formControlName="customer_ct_pat">CT-PAT</mat-checkbox>
              <mat-checkbox formControlName="customer_canada_bond">Canada Bond</mat-checkbox>
              <mat-checkbox formControlName="customer_us_bond">US Bond</mat-checkbox>
              <mat-checkbox formControlName="customer_hazmat">HAZMAT</mat-checkbox>
              <mat-checkbox formControlName="customer_protect_from_freezing">Protect From Freezing</mat-checkbox>
              <mat-checkbox formControlName="customer_heated">Heated</mat-checkbox>
              <mat-checkbox formControlName="customer_refrigeration">Refrigeration</mat-checkbox>
              <mat-checkbox formControlName="customer_food_grade">Food Grade</mat-checkbox>
            </div>
          </mat-expansion-panel>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>Default Service Charges</mat-expansion-panel-header>

            <div formArrayName="customer_service_charges" class="service-charges-container">
              <div *ngIf="!customerServiceCharges.controls.length" class="no-services-message">
                <p>No default services for this customer. You can add one manually.</p>
              </div>

              <div
                *ngFor="let service of customerServiceCharges.controls; let i = index"
                [formGroupName]="i"
                class="service-charge-item"
              >
                <ng-container *ngIf="service.value.is_default">
                  <div class="service-details">
                    <mat-icon class="service-origin-icon" matTooltip="Default Service">verified</mat-icon>
                    <span class="service-name">{{ service.value.service }}</span>
                    <span class="service-type">({{ service.value.service_type }})</span>
                  </div>
                </ng-container>

                <ng-container *ngIf="!service.value.is_default">
                  <div class="manual-service-form">
                    <mat-form-field appearance="outline" class="enhanced-input">
                      <mat-label>Service Category</mat-label>
                      <mat-select formControlName="service" (selectionChange)="onServiceCategoryChange(service)">
                        <mat-option *ngFor="let cat of serviceCategories" [value]="cat">{{ cat }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="enhanced-input">
                      <mat-label>Service Type</mat-label>
                      <mat-select formControlName="service_type">
                        <mat-option *ngFor="let type of serviceTypes[service.value.service]" [value]="type">
                          {{ type }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ng-container>

                <button mat-icon-button color="warn" (click)="removeCustomerServiceCharge(i)" matTooltip="Remove Service">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>

            <button mat-stroked-button color="primary" (click)="addManualCustomerServiceCharge()" class="add-item-button">
              <mat-icon>add</mat-icon>
              Add Service Charge
            </button>
          </mat-expansion-panel>

          <mat-form-field appearance="outline" color="primary" class="enhanced-input">
            <mat-label>Rate Method</mat-label>
            <mat-select formControlName="rate_method">
              <mat-option value="1">Cubic Feet</mat-option>
              <mat-option value="2">Weight</mat-option>
              <mat-option value="3">Linear Feet</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </form>

      <!-- Shipper -->
      <form *ngSwitchCase="1" class="step-card" [formGroup]="shipperForm">
        <div class="card-content">
          <app-contact-autocomplete
            placeholder="Search shipper…"
            [type]="'shipper_contact_list'"
            [formControl]="shipperNameControl"
            (selected)="onShipperSelected($event)"
          ></app-contact-autocomplete>

          <div class="address-row">
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Shipper Address</mat-label>
              <mat-select formControlName="shipper_address">
                <mat-option *ngFor="let a of shipperAddresses" [value]="a.value">{{ a.label }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Postal Code</mat-label>
              <input matInput formControlName="shipper_postal_code">
            </mat-form-field>
          </div>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>Shipper Details</mat-expansion-panel-header>
            <div class="checkbox-group">
              <mat-checkbox formControlName="shipper_loading_dock">Loading Dock</mat-checkbox>
              <mat-checkbox formControlName="shipper_pickup_tailgate">Tailgate at Pick-Up</mat-checkbox>
              <mat-checkbox formControlName="shipper_truck_space">Truck Space</mat-checkbox>
              <mat-checkbox formControlName="shipper_pickup_straight_truck">Straight Truck</mat-checkbox>
              <mat-checkbox formControlName="shipper_bol_required">Requires BOL</mat-checkbox>
            </div>
          </mat-expansion-panel>

          <mat-form-field appearance="outline" color="primary" class="enhanced-input">
            <mat-label>Pick-Up Reference</mat-label>
            <input matInput formControlName="shipper_pickup_reference">
          </mat-form-field>
          <mat-form-field appearance="outline" color="primary" class="enhanced-input">
            <mat-label>Estimated Pickup Date</mat-label>
            <input matInput [matDatepicker]="shipperEstimatedPicker" formControlName="estimated_date_shipper">
            <mat-datepicker-toggle matIconSuffix [for]="shipperEstimatedPicker"></mat-datepicker-toggle>
            <mat-datepicker #shipperEstimatedPicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline" color="primary" class="enhanced-input">
            <mat-label>Estimated Pickup Time</mat-label>
            <input matInput type="time" formControlName="estimated_time_start_shipper">
          </mat-form-field>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>Location Type</mat-expansion-panel-header>
            <div class="checkbox-group">
              <mat-checkbox formControlName="shipper_is_residential">Residential</mat-checkbox>
              <mat-checkbox formControlName="shipper_is_commercial">Commercial</mat-checkbox>
              <mat-checkbox formControlName="shipper_is_job_site">Job Site</mat-checkbox>
            </div>
          </mat-expansion-panel>

          <div *ngIf="shipperForm.get('shipper_is_job_site')!.value">
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>Job Site Details</mat-expansion-panel-header>
              <div class="checkbox-group">
                <mat-checkbox formControlName="shipper_lift_lull">Forklift or Lull</mat-checkbox>
                <mat-checkbox formControlName="shipper_call_site">Call Site</mat-checkbox>
                <mat-checkbox formControlName="shipper_unmanned_job_site">Unmanned Job Site</mat-checkbox>
                <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                  <mat-label>Job Site Contact Name</mat-label>
                  <input matInput formControlName="shipper_job_site_contact_name">
                </mat-form-field>
                <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                  <mat-label>Job Site Contact Phone</mat-label>
                  <input matInput formControlName="shipper_job_site_contact_phone">
                </mat-form-field>
              </div>
            </mat-expansion-panel>
          </div>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>Other Site Info</mat-expansion-panel-header>
            <div class="checkbox-group">
              <mat-checkbox formControlName="shipper_is_convention_center">Convention Center</mat-checkbox>
              <mat-checkbox formControlName="shipper_is_pop_up">Pop-Up Store</mat-checkbox>
              <mat-checkbox formControlName="appointment_shipper">Appointment required?</mat-checkbox>
            </div>
          </mat-expansion-panel>

          <div *ngIf="shipperForm.get('appointment_shipper')!.value">
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Appointment Date</mat-label>
              <input matInput [matDatepicker]="shipperAppointmentPicker" formControlName="appointment_date_shipper">
              <mat-datepicker-toggle matIconSuffix [for]="shipperAppointmentPicker"></mat-datepicker-toggle>
              <mat-datepicker #shipperAppointmentPicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Window Start</mat-label>
              <input matInput type="time" formControlName="appointment_time_start_shipper">
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Window End</mat-label>
              <input matInput type="time" formControlName="appointment_time_end_shipper">
            </mat-form-field>
          </div>
        </div>
      </form>

      <!-- Consignee -->
      <form *ngSwitchCase="2" class="step-card" [formGroup]="consigneeForm">
        <div class="card-content">
          <app-contact-autocomplete
            placeholder="Search consignee…"
            [type]="'consignee_contact_list'"
            [formControl]="consigneeNameControl"
            (selected)="onConsigneeSelected($event)"
          ></app-contact-autocomplete>

          <div class="address-row">
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Consignee Address</mat-label>
              <mat-select formControlName="consignee_address">
                <mat-option *ngFor="let a of consigneeAddresses" [value]="a.value">{{ a.label }}</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Postal Code</mat-label>
              <input matInput formControlName="consignee_postal_code">
            </mat-form-field>
          </div>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>Consignee Details</mat-expansion-panel-header>
            <div class="checkbox-group">
              <mat-checkbox formControlName="consignee_loading_dock">Loading Dock</mat-checkbox>
              <mat-checkbox formControlName="consignee_pickup_tailgate">Tailgate at Delivery</mat-checkbox>
              <mat-checkbox formControlName="consignee_truck_space">Truck Space</mat-checkbox>
              <mat-checkbox formControlName="consignee_pickup_straight_truck">Straight Truck</mat-checkbox>
              <mat-checkbox formControlName="consignee_bol_required">Requires BOL</mat-checkbox>
            </div>
          </mat-expansion-panel>

          <mat-form-field appearance="outline" color="primary" class="enhanced-input">
            <mat-label>Delivery Reference</mat-label>
            <input matInput formControlName="consignee_delivery_reference">
          </mat-form-field>
          <mat-form-field appearance="outline" color="primary" class="enhanced-input">
            <mat-label>Estimated Delivery Date</mat-label>
            <input matInput [matDatepicker]="consigneeEstimatedPicker" formControlName="estimated_date_consignee">
            <mat-datepicker-toggle matIconSuffix [for]="consigneeEstimatedPicker"></mat-datepicker-toggle>
            <mat-datepicker #consigneeEstimatedPicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field appearance="outline" color="primary" class="enhanced-input">
            <mat-label>Delivery Time</mat-label>
            <input matInput type="time" formControlName="estimated_time_end_consignee">
          </mat-form-field>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>Location Type</mat-expansion-panel-header>
            <div class="checkbox-group">
              <mat-checkbox formControlName="consignee_is_residential">Residential</mat-checkbox>
              <mat-checkbox formControlName="consignee_is_commercial">Commercial</mat-checkbox>
              <mat-checkbox formControlName="consignee_is_job_site">Job Site</mat-checkbox>
            </div>
          </mat-expansion-panel>

          <div *ngIf="consigneeForm.get('consignee_is_job_site')!.value">
            <mat-expansion-panel [expanded]="true">
              <mat-expansion-panel-header>Job Site Details</mat-expansion-panel-header>
              <div class="checkbox-group">
                <mat-checkbox formControlName="consignee_lift_lull">Forklift or Lull</mat-checkbox>
                <mat-checkbox formControlName="consignee_call_site">Call Site</mat-checkbox>
                <mat-checkbox formControlName="consignee_unmanned_job_site">Unmanned Job Site</mat-checkbox>
                <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                  <mat-label>Job Site Contact Name</mat-label>
                  <input matInput formControlName="consignee_job_site_contact_name">
                </mat-form-field>
                <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                  <mat-label>Job Site Contact Phone</mat-label>
                  <input matInput formControlName="consignee_job_site_contact_phone">
                </mat-form-field>
              </div>
            </mat-expansion-panel>
          </div>

          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>Other Site Info</mat-expansion-panel-header>
            <div class="checkbox-group">
              <mat-checkbox formControlName="consignee_is_convention_center">Convention Center</mat-checkbox>
              <mat-checkbox formControlName="consignee_is_pop_up">Pop-Up Store</mat-checkbox>
              <mat-checkbox formControlName="appointment_consignee">Appointment required?</mat-checkbox>
            </div>
          </mat-expansion-panel>

          <div *ngIf="consigneeForm.get('appointment_consignee')!.value">
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Delivery Date</mat-label>
              <input matInput [matDatepicker]="consigneeAppointmentPicker" formControlName="appointment_date_consignee">
              <mat-datepicker-toggle matIconSuffix [for]="consigneeAppointmentPicker"></mat-datepicker-toggle>
              <mat-datepicker #consigneeAppointmentPicker></mat-datepicker>
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Window Start</mat-label>
              <input matInput type="time" formControlName="appointment_time_start_consignee">
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Window End</mat-label>
              <input matInput type="time" formControlName="appointment_time_end_consignee">
            </mat-form-field>
          </div>
        </div>
      </form>

      <!-- Manifest / Load details -->
      <form *ngSwitchCase="3" class="step-card" [formGroup]="loadDetailsForm">
        <div class="card-content">

         <!-- Lading scope selection with multi-select and chip repeater -->
         <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>Lading Scope</mat-expansion-panel-header>

          <mat-form-field appearance="outline" color="primary" class="enhanced-input full-width">
            <mat-label>Select lading scope(s)</mat-label>
            <mat-select formControlName="lading_scope" multiple>
              <mat-option *ngFor="let s of ladingScopes" [value]="s.id">
                {{ s.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div *ngIf="selectedScopeIds.length">
            <mat-chip-set aria-label="Selected Lading Scopes">
              <mat-chip 
                *ngFor="let id of selectedScopeIds; trackBy: trackById" 
                (removed)="removeScope(id)">
                {{ ladingScopesById[id].name || ('Scope ' + id) }}
                <button matChipRemove [attr.aria-label]="'Remove ' + (ladingScopesById[id].name || '')">
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip>
            </mat-chip-set>
          </div>

          <mat-form-field *ngIf="hasScope(3) || hasScope(4)" appearance="fill" color="primary" class="enhanced-input">
            <mat-label>Customs Broker</mat-label>
            <input matInput formControlName="custom_broker_name">
          </mat-form-field>
        </mat-expansion-panel>

          <!-- Packaging -->
          <mat-expansion-panel formGroupName="packaging_type" [expanded]="true">
            <mat-expansion-panel-header>Packaging Type</mat-expansion-panel-header>
            <div class="checkbox-group">
              <mat-checkbox formControlName="palleted">Palleted</mat-checkbox>
              <mat-checkbox formControlName="carton">Carton</mat-checkbox>
              <mat-checkbox formControlName="crate">Crate</mat-checkbox>
              <mat-checkbox formControlName="loose_floor">Loose/Floor</mat-checkbox>
            </div>
          </mat-expansion-panel>

          <!-- Operations -->
          <mat-expansion-panel formGroupName="operations" [expanded]="true">
            <mat-expansion-panel-header>Operations</mat-expansion-panel-header>
            <div class="checkbox-group">
              <mat-checkbox formControlName="carrier_rated">Carrier Rated</mat-checkbox>
              <mat-checkbox formControlName="carrier_rerated">Carrier Re-Rated</mat-checkbox>
              <mat-checkbox formControlName="straps_bars">Straps & Bars</mat-checkbox>
              <mat-checkbox formControlName="protective_equipment">Protective Equipment</mat-checkbox>
              <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                <mat-label>Operations Notation</mat-label>
                <input matInput formControlName="operations_notation">
              </mat-form-field>
            </div>
          </mat-expansion-panel>

          <!-- Equipment -->
          <div formGroupName="equipment" class="address-row">
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Type of Equipment</mat-label>
              <input matInput formControlName="type_of_equipment">
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Equipment Options</mat-label>
              <input matInput formControlName="equipment_options">
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Partial or Full</mat-label>
              <mat-select formControlName="partial_or_full">
                <mat-option value="Partial">Partial</mat-option>
                <mat-option value="Full">Full</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <!-- Household Import -->
          <mat-expansion-panel formGroupName="household_import" [expanded]="true">
            <mat-expansion-panel-header>Household Import</mat-expansion-panel-header>
            <div class="checkbox-group">
              <mat-checkbox formControlName="importing_passport">Passports</mat-checkbox>
              <mat-checkbox formControlName="importing_work_permit_visa">Work Permit/Visa</mat-checkbox>
              <mat-checkbox formControlName="importing_inventory_listing">Inventory Listing</mat-checkbox>
              <mat-checkbox formControlName="importing_new_canadian_address">New Canadian Address</mat-checkbox>
              <mat-checkbox formControlName="importing_scale_tickets">Scale Tickets</mat-checkbox>
            </div>
          </mat-expansion-panel>

          <!-- Household Export -->
          <mat-expansion-panel formGroupName="household_export" [expanded]="true">
            <mat-expansion-panel-header>Household Export</mat-expansion-panel-header>
            <div class="checkbox-group">
              <mat-checkbox formControlName="exporting_passport">Passports</mat-checkbox>
              <mat-checkbox formControlName="exporting_form_3299">Form 3299</mat-checkbox>
              <mat-checkbox formControlName="exporting_power_of_attorney">Power of Attorney</mat-checkbox>
              <mat-checkbox formControlName="exporting_supplemental_declaration">Supplemental Declaration</mat-checkbox>
              <mat-checkbox formControlName="exporting_inventory_listing">Inventory Listing</mat-checkbox>
              <mat-checkbox formControlName="exporting_i94">I-94 Card</mat-checkbox>
              <mat-checkbox formControlName="exporting_scale_tickets">Scale Tickets</mat-checkbox>
            </div>
          </mat-expansion-panel>

          <!-- Pallets & Products -->
          <app-dispatch-freight-workbench
            *ngIf="dispatchFreightPhase1Enabled"
            mode="edit"
            [draft]="dispatchFreightDraft"
            [context]="dispatchFreightBridge.context"
            [preferredRateMethod]="dispatchFreightBridge.preferredRateMethod"
            [rateState]="dispatchRateState"
            [rateResponse]="dispatchRateResponse"
            [rateError]="dispatchRateError"
            (draftChange)="onDispatchFreightChange($event)"
            (rateRequested)="onDispatchRateRequested($event)"
          ></app-dispatch-freight-workbench>

          <mat-expansion-panel *ngIf="!dispatchFreightPhase1Enabled" [expanded]="true">
            <mat-expansion-panel-header>Pallets & Products</mat-expansion-panel-header>

            <div formArrayName="pallets_products" class="dynamic-form-array-container">
              <button mat-stroked-button color="primary" (click)="addPalletProductSet()" class="add-item-button">
                <mat-icon>add</mat-icon>
                Add Pallet / Product
              </button>

              <div *ngIf="!palletsProducts.controls.length" class="empty-array-message">
                <p>No items have been added yet. Click the button to add a pallet or product.</p>
              </div>

              <mat-card *ngFor="let grp of palletsProducts.controls; let i = index" [formGroupName]="i" class="dynamic-card">
                <div class="dynamic-card-header">
                  <mat-button-toggle-group formControlName="mode" aria-label="Select Mode">
                    <mat-button-toggle value="pallet">Pallets</mat-button-toggle>
                    <mat-button-toggle value="product">Products</mat-button-toggle>
                  </mat-button-toggle-group>
                  <button mat-icon-button color="warn" (click)="removePalletProductSet(i)" matTooltip="Delete this item">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>

                <div *ngIf="grp.get('mode')!.value === 'pallet'" class="address-row">
                  <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                    <mat-label># of Pallets</mat-label>
                    <input matInput placeholder="# Pallets" formControlName="pallet_num">
                  </mat-form-field>
                  <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                    <mat-label>Length</mat-label>
                    <input matInput placeholder="Length" formControlName="pallet_length">
                  </mat-form-field>
                  <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                    <mat-label>Width</mat-label>
                    <input matInput placeholder="Width" formControlName="pallet_width">
                  </mat-form-field>
                  <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                    <mat-label>Height</mat-label>
                    <input matInput placeholder="Height" formControlName="pallet_height">
                  </mat-form-field>
                  <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                    <mat-label>Weight</mat-label>
                    <input matInput placeholder="Weight" formControlName="pallet_weight">
                  </mat-form-field>
                </div>

                <div *ngIf="grp.get('mode')!.value === 'product'" class="address-row">
                  <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                    <mat-label>Model #</mat-label>
                    <input matInput placeholder="Model #" formControlName="product_model_number">
                  </mat-form-field>
                  <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                    <mat-label>Qty</mat-label>
                    <input matInput placeholder="Qty" formControlName="product_quantity">
                  </mat-form-field>
                  <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                    <mat-label>Length</mat-label>
                    <input matInput placeholder="Length" formControlName="product_length">
                  </mat-form-field>
                  <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                    <mat-label>Width</mat-label>
                    <input matInput placeholder="Width" formControlName="product_width">
                  </mat-form-field>
                  <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                    <mat-label>Height</mat-label>
                    <input matInput placeholder="Height" formControlName="product_height">
                  </mat-form-field>
                  <mat-form-field appearance="outline" color="primary" class="enhanced-input">
                    <mat-label>Weight</mat-label>
                    <input matInput placeholder="Weight" formControlName="product_weight">
                  </mat-form-field>
                  <mat-form-field appearance="outline" color="primary" class="enhanced-input full-width">
                    <mat-label>Description</mat-label>
                    <input matInput placeholder="Description" formControlName="product_description">
                  </mat-form-field>
                </div>
              </mat-card>
            </div>
          </mat-expansion-panel>

          <!-- Service Charges -->
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>Service Charges</mat-expansion-panel-header>

            <div formArrayName="service_charges" class="service-charges-container">
              <div *ngIf="!serviceCharges.controls.length" class="no-services-message">
                <p>No default services added. Select a shipper or consignee with default services, or add one manually.</p>
              </div>

              <div
                *ngFor="let service of serviceCharges.controls; let i = index"
                [formGroupName]="i"
                class="service-charge-item"
              >
                <ng-container *ngIf="service.value.is_default">
                  <div class="service-details">
                    <mat-icon class="service-origin-icon" [matTooltip]="service.value.origin">
                      {{ service.value.origin === 'shipper' ? 'fa-box' : 'fa-box-open' }}
                    </mat-icon>
                    <span class="service-name">{{ service.value.service }}</span>
                    <span class="service-type">({{ service.value.service_type }})</span>
                  </div>
                </ng-container>

                <ng-container *ngIf="!service.value.is_default">
                  <div class="manual-service-form">
                    <mat-radio-group formControlName="origin" aria-label="Select an origin">
                      <mat-radio-button value="shipper">Shipper</mat-radio-button>
                      <mat-radio-button value="consignee">Consignee</mat-radio-button>
                    </mat-radio-group>
                    <mat-form-field appearance="outline" class="enhanced-input">
                      <mat-label>Service Category</mat-label>
                      <mat-select formControlName="service" (selectionChange)="onServiceCategoryChange(service)">
                        <mat-option *ngFor="let cat of serviceCategories" [value]="cat">{{ cat }}</mat-option>
                      </mat-select>
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="enhanced-input">
                      <mat-label>Service Type</mat-label>
                      <mat-select formControlName="service_type">
                        <mat-option *ngFor="let type of serviceTypes[service.value.service]" [value]="type">
                          {{ type }}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>
                </ng-container>

                <button mat-icon-button color="warn" (click)="removeServiceCharge(i)" matTooltip="Remove Service">
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>

            <button mat-stroked-button color="primary" (click)="addManualServiceCharge()" class="add-item-button">
              <mat-icon>add</mat-icon>
              Add Service Charge
            </button>
          </mat-expansion-panel>

          <!-- Additional Info -->
          <div formGroupName="additional_info" class="address-row">
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Product Status</mat-label>
              <mat-select formControlName="product_status">
                <mat-option value="1">New</mat-option>
                <mat-option value="2">Used</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Booking #</mat-label>
              <input matInput formControlName="booking_number">
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Release #</mat-label>
              <input matInput formControlName="release_number">
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>BOL #</mat-label>
              <input matInput formControlName="lading_number">
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Trip #</mat-label>
              <input matInput formControlName="trip_number">
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Shipment #</mat-label>
              <input matInput formControlName="shipment_number">
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Requirements</mat-label>
              <input matInput formControlName="requirements">
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary" class="enhanced-input full-width">
              <mat-label>Details</mat-label>
              <textarea matInput formControlName="load_details"></textarea>
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary" class="enhanced-input full-width">
              <mat-label>Special Info</mat-label>
              <textarea matInput formControlName="load_special_info"></textarea>
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Load Length</mat-label>
              <input matInput formControlName="load_length">
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Value Unit</mat-label>
              <mat-select formControlName="load_value_unit">
                <mat-option value="USD">USD</mat-option>
                <mat-option value="CND">CND</mat-option>
                <mat-option value="OTHER">OTHER</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field appearance="outline" color="primary" class="enhanced-input">
              <mat-label>Load Value</mat-label>
              <input matInput formControlName="load_value">
            </mat-form-field>
          </div>
        </div>
      </form>

      <!-- Rates -->
      <form *ngSwitchCase="4" class="step-card" [formGroup]="ratesForm">
        <div class="card-content">
          <app-dispatch-freight-workbench
            *ngIf="dispatchFreightPhase1Enabled"
            mode="rate"
            [draft]="dispatchFreightDraft"
            [context]="dispatchFreightBridge.context"
            [preferredRateMethod]="dispatchFreightBridge.preferredRateMethod"
            [rateState]="dispatchRateState"
            [rateResponse]="dispatchRateResponse"
            [rateError]="dispatchRateError"
            (draftChange)="onDispatchFreightChange($event)"
            (rateRequested)="onDispatchRateRequested($event)"
          ></app-dispatch-freight-workbench>

          <app-dispatch-manifest-append
            *ngIf="dispatchFreightPhase1Enabled"
            [customerContactUuid]="customerForm.get('customer_uuid')?.value || ''"
            [ratingRequest]="dispatchRateState === 'rated' ? dispatchFreightRatingRequest : null"
            [appendDetails]="dispatchAppendNewLegDetails"
          ></app-dispatch-manifest-append>

          <ng-container *ngIf="!dispatchFreightPhase1Enabled">
            <button mat-raised-button color="primary" (click)="loadRater()" type="button" class="choose-carrier">
              Choose Carrier (Optional)
            </button>
            <app-freightmancers-rate-friend
              *ngIf="showRater"
              [ladingInfo]="raterArg"
              (carrierConfirmed)="setCarrier($event)"
            />
          </ng-container>
        </div>
      </form>

      <div *ngSwitchCase="5" class="step-card">
        <div class="card-content">
          <mat-form-field>
            <mat-label>Lading Status</mat-label>
            <mat-select [formControl]="statusForm">
              <mat-option *ngFor="let s of ladingStatuses" [value]="s">{{s}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

    </ng-container>
  </div>
</section>

<div class="wiz-actions" [class.single]="active === 0">
  <button *ngIf="active > 0" type="button" (click)="prev()">
    <i class="fas fa-chevron-left"></i>&nbsp; Back
  </button>
  <button *ngIf="active < steps.length - 1" type="button" (click)="next()">
    Next &nbsp;<i class="fas fa-chevron-right"></i>
  </button>
  <button *ngIf="active === steps.length - 1" type="button" class="finish" (click)="submit()">
    Finish &nbsp;<i class="fas fa-wand-sparkles"></i>
  </button>
</div>

<div class="wiz-scroll-tail"></div>

<ng-template #customerProfileSaveDialog let-dialogRef="dialogRef">
  <h2 mat-dialog-title>Action Required</h2>
  <mat-dialog-content>
    A change in customer options was detected. Do you want to change the customer profile for future ladings?
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-button (click)="dialogRef.close()">No</button>
    <button mat-button (click)="dialogRef.close()">Yes</button>
  </mat-dialog-actions>
</ng-template>
